
export function Button({ children, type = "button", disabled = false, variant = "primary", className = '', ...props }) {
    const variantClasses = {
        primary: 'bg-blue-500 hover:bg-blue-600',
        subse: 'bg-[#476c97] hover:bg-[#476c97]',
        subse_green: 'bg-[#50bb47] hover:bg-[#50bb47]',
        secondary: 'bg-amber-500 hover:bg-amber-600',
        success: 'bg-green-500 hover:bg-green-600',
        danger: 'bg-red-500 hover:bg-red-600',
        dark: 'bg-gray-700 hover:bg-gray-800'
    };

    const baseClasses = disabled 
        ? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
        : `${variantClasses[variant] || variantClasses.primary} text-white`;

    return (
        <button
            type={type}
            className={`w-full p-2 rounded-md transition-colors ${baseClasses} ${className}`}
            disabled={disabled}
            {...props}
        >
            {children}
        </button>
    )
}

//nuevo w-full bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600

//viejo flex w-full justify-center rounded-md bg-cyan-500  dark:bg-cyan-700 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600